import React, { useEffect, useMemo, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { carData } from "@/data/carData";

export default function VehicleDetail() {
  const { vin } = useParams();
  const navigate = useNavigate();

  const vehicle = useMemo(() => {
    return carData[(vin || "").toUpperCase()] || null;
  }, [vin]);

  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [viewerOpen, setViewerOpen] = useState(false);
  const [zoom, setZoom] = useState(1);

  useEffect(() => {
    document.title = "JTDKAMFP4N3226551 Toyota Prius 2022 VIN Report & Images";
  }, []);

  if (!vehicle) {
    return (
      <div style={{ background: "#000", color: "#fff", minHeight: "100vh", padding: "40px" }}>
        <h1>Vehicle not found</h1>
        <button onClick={() => navigate("/")} style={{ padding: "10px 16px", cursor: "pointer" }}>
          Back
        </button>
      </div>
    );
  }

  const images = vehicle.images || [];

  const openViewer = (index) => {
    setSelectedImageIndex(index);
    setZoom(1);
    setViewerOpen(true);
  };

  const closeViewer = () => {
    setViewerOpen(false);
    setZoom(1);
  };

  const nextImage = () => {
    setSelectedImageIndex((prev) => (prev + 1) % images.length);
    setZoom(1);
  };

  const prevImage = () => {
    setSelectedImageIndex((prev) => (prev - 1 + images.length) % images.length);
    setZoom(1);
  };

  return (
    <div style={{ background: "#000", color: "#fff", minHeight: "100vh", padding: "20px" }}>
      <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
        <button
          onClick={() => navigate("/")}
          style={{
            marginBottom: "20px",
            padding: "10px 16px",
            cursor: "pointer",
            background: "#111",
            color: "#fff",
            border: "1px solid #333"
          }}
        >
          Back to Search
        </button>

        <div style={{ background: "#0b0b0b", padding: "20px", borderRadius: "8px", border: "1px solid #222" }}>
          <div style={{ textAlign: "center", marginBottom: "16px" }}>
            <img
              src={images[selectedImageIndex]}
              alt={`Toyota Prius 2022 VIN JTDKAMFP4N3226551 image ${selectedImageIndex + 1}`}
              onClick={() => openViewer(selectedImageIndex)}
              style={{
                maxWidth: "100%",
                maxHeight: "420px",
                objectFit: "contain",
                cursor: "zoom-in"
              }}
            />
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(90px, 1fr))",
              gap: "8px",
              marginBottom: "24px"
            }}
          >
            {images.map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`Toyota Prius 2022 VIN JTDKAMFP4N3226551 image ${index + 1}`}
                onClick={() => setSelectedImageIndex(index)}
                style={{
                  width: "100%",
                  height: "80px",
                  objectFit: "cover",
                  cursor: "pointer",
                  border: selectedImageIndex === index ? "2px solid #3b82f6" : "2px solid #222"
                }}
              />
            ))}
          </div>

          <h1 style={{ fontSize: "42px", marginBottom: "10px" }}>
            {vehicle.year} {vehicle.make} {vehicle.model}
          </h1>

          <p style={{ color: "#aaa", marginBottom: "20px" }}>VIN: {vehicle.vin}</p>

          <div style={{ background: "#2a0f0f", padding: "14px", marginBottom: "16px", borderRadius: "6px" }}>
            <strong>Accident History:</strong> {vehicle.accident_history}
          </div>

          <div style={{ background: "#1a1a1a", padding: "14px", marginBottom: "24px", borderRadius: "6px" }}>
            <strong>Notes:</strong> {vehicle.notes}
          </div>

          <h2 style={{ fontSize: "28px", marginBottom: "16px" }}>Technical Specifications</h2>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
              gap: "12px"
            }}
          >
            <div style={{ background: "#111", padding: "14px", border: "1px solid #222" }}>
              <strong>Make:</strong> {vehicle.make}
            </div>
            <div style={{ background: "#111", padding: "14px", border: "1px solid #222" }}>
              <strong>Model:</strong> {vehicle.model}
            </div>
            <div style={{ background: "#111", padding: "14px", border: "1px solid #222" }}>
              <strong>Year:</strong> {vehicle.year}
            </div>
            <div style={{ background: "#111", padding: "14px", border: "1px solid #222" }}>
              <strong>Mileage:</strong> {vehicle.mileage}
            </div>
            <div style={{ background: "#111", padding: "14px", border: "1px solid #222" }}>
              <strong>Body Class:</strong> {vehicle.body_class}
            </div>
            <div style={{ background: "#111", padding: "14px", border: "1px solid #222" }}>
              <strong>Engine:</strong> {vehicle.engine}
            </div>
            <div style={{ background: "#111", padding: "14px", border: "1px solid #222" }}>
              <strong>Transmission:</strong> {vehicle.transmission}
            </div>
            <div style={{ background: "#111", padding: "14px", border: "1px solid #222" }}>
              <strong>Drive Type:</strong> {vehicle.drive_type}
            </div>
            <div style={{ background: "#111", padding: "14px", border: "1px solid #222" }}>
              <strong>Fuel Type:</strong> {vehicle.fuel_type}
            </div>
          </div>
        </div>
      </div>

      {viewerOpen && (
        <div
          onClick={closeViewer}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.95)",
            zIndex: 9999,
            display: "flex",
            flexDirection: "column"
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "16px",
              borderBottom: "1px solid rgba(255,255,255,0.1)"
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ color: "#fff" }}>
              Image {selectedImageIndex + 1} / {images.length}
            </div>

            <div style={{ display: "flex", gap: "8px" }}>
              <button
                onClick={() => setZoom((z) => Math.max(1, z - 0.25))}
                style={{ padding: "8px 12px", cursor: "pointer" }}
              >
                -
              </button>
              <button
                onClick={() => setZoom((z) => Math.min(3, z + 0.25))}
                style={{ padding: "8px 12px", cursor: "pointer" }}
              >
                +
              </button>
              <button
                onClick={closeViewer}
                style={{ padding: "8px 12px", cursor: "pointer" }}
              >
                X
              </button>
            </div>
          </div>

          <div
            style={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
              overflow: "auto",
              padding: "20px"
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {images.length > 1 && (
              <button
                onClick={prevImage}
                style={{
                  position: "absolute",
                  left: "20px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  zIndex: 2,
                  padding: "12px 16px",
                  cursor: "pointer"
                }}
              >
                {"<"}
              </button>
            )}

            <img
              src={images[selectedImageIndex]}
              alt={`Toyota Prius 2022 VIN JTDKAMFP4N3226551 image ${selectedImageIndex + 1}`}
              style={{
                transform: `scale(${zoom})`,
                transformOrigin: "center center",
                maxHeight: "85vh",
                maxWidth: "95vw",
                objectFit: "contain"
              }}
            />

            {images.length > 1 && (
              <button
                onClick={nextImage}
                style={{
                  position: "absolute",
                  right: "20px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  zIndex: 2,
                  padding: "12px 16px",
                  cursor: "pointer"
                }}
              >
                {">"}
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}